import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { CategoryModel } from 'app/models/category-model';
import { PipesModule } from 'app/pipes/pipes.module';
import { ProductModel } from 'app/models/product-model';


@Component({
  selector: 'app-product-summary',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatDividerModule,
    PipesModule
  ],
  templateUrl: './product-summary.component.html',
  styleUrls: ['./product-summary.component.scss']
})
export class ProductSummaryComponent {

  @Input() product!: ProductModel;
  @Input() categories: CategoryModel[];

  get category(){
    return this.categories.find(c=> c.id==this.product?.categoryId);
  }

  getUnitLabel(unit: string): string {
    switch (unit) {
      case 'TIME_DAY': return 'día';
      case 'TIME_HOUR': return 'hora';
      case 'TIME_MINUTE': return 'min';
      default: return unit;
    }
  }
}
